// extracted by mini-css-extract-plugin
module.exports = {"container":"ResidencyPoster_container_3Pugd","logo":"ResidencyPoster_logo_MXiCl","information":"ResidencyPoster_information_2u59r"};